<template>
  <div
    class="sidebar-subnav"
  >
    <transition name="fade">
      <div class="sidebar-subnav__wrapper" v-show="navItems.length || activeNavItems.length">
        <transition-group
          class="sidebar-subnav__nav-items"
          @before-enter="beforeEnter"
          @enter="enter"
          @afterEnter="afterEnter"
          @leave="leave"
        >     
          <div
            v-for="(navItem, index) in navItems"
            class="sidebar-subnav__nav-item-wrapper"
            :data-index="index"
            :key="navItem._id"
          >
            <router-link
              class="btn touch"
              :class="{ 'filtered': navItem.filter }"
              tag="button"
              :to="getItemUrl(navItem)"
              @click.native="playClickSound(); bus.$emit('navClick'); bus.$emit('startAnimations')"
              :dir="lang.rtl ? 'rtl' : 'ltr'"
            >
              <div v-if="navItem.icon && navItem.icon[1]" class="btn__icon">
                <fa :icon="navItem.icon"/>
              </div>
              <div
                
                v-html="navItem.label[lang.code] || navItem.label['en']"
              ></div>
            </router-link>
          </div>
        </transition-group>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { bus } from '../main'
import _ from 'lodash'

export default {
  props: ['nav-items'],

  data () {
    return {
      activeNavItems: [],
      bus: bus
    }
  },

  computed: {
    ...mapGetters({
      activePage: 'activePage',
      lang: 'language',
      styles: 'styleTemplate'
    }),
  },

  mounted () {
    bus.$on('animateSubBottomBar', () => {
      if (!_.isEqual(this.activeNavItems, this.navItems)) {
        setTimeout(() => {
          this.activeNavItems = this.navItems
        }, 300)
        
      } else {
        bus.$emit('finishedAnimation', 'SubBottomBar')
      }
    })
  },

  methods: {
    ...mapActions([
      'playClickSound'
    ]),

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        done()
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        bus.$emit('finishedAnimation', 'SubBottomBar')
      }
    },    

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0)`
    },

    getItemUrl (navItem) {
      if (navItem.customRoute) {
        return navItem.customRoute
      }

      if (navItem.pageId) {
        return /category/ + this.$store.state.route.params.categoryId + '/page/' + navItem.pageId
      }

      if (navItem.to) {
        return navItem.to
      }

      return ''
    },

    isNavItemActive (item) {
      if (item.customRoute) {
        if (this.$route.fullPath.includes(item.customRoute)) {
          return true
        }
      }

      if (item.to) {
        if (this.$route.fullPath.includes(item.to)) {
          return true
        }
      }

      return this.activePage && (item.pageId === this.activePage._id || _.find(item.children, child => {
        return child.pageId === this.activePage._id
      }))
    },
  },
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_buttons.scss";

.padding-level {
  &--0 {
    padding: 0 5.5rem;
  }

  &--1 {
    padding: 0 14.5rem;
  }

  &--2 {
    padding: 0 24rem;
  }
}

.sidebar-subnav {
  &__nav-items {

    

    .btn {
      align-items: center;
      color: $white;
      display: flex;
      font-size: 1.1rem;
      font-weight: 300;
      height: 2.5rem;
      justify-content: flex-start;
      // letter-spacing: .15rem;
      line-height: 0;
      margin: 0 0 1.4rem;
      padding: .2rem 1.5rem 0;
      width: auto;

      &.filtered {
        opacity: 0.3;
        // pointer-events: none !important;

        * {
          // pointer-events: none !important;
        }
      }

      &__icon {
        margin-left: -1rem;
      }

      &.router-link-active {
        color: $black;
      }

      div {
        height: auto;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>